import i18next from 'i18next'

export interface TableStatistics {
    type: GroupStatistics
    value: number
}

export enum GroupStatistics {
    POINTS = 'points',
    APPEARANCE = 'appearance',
    VICTORY = 'victory',
    DRAW = 'draw',
    DEFEAT = 'defeat',
    GOALS = 'goals',
    BASKETS = 'baskets',
    CONCEDED_GOALS = 'conceded-goals',
    CONCEDED_BASKETS = 'conceded-baskets',
    WON_SETS = 'won-sets',
    LOST_SETS = 'lost-sets',
    GAMES_WON = 'games-won',
    GAMES_LOST = 'games-lost',
    GOAL_DIFFERENCE = 'goal-difference',
    BASKET_DIFFERENCE = 'basket-difference',
    SETS_DIFFERENCE = 'sets-difference',
    GAMES_DIFFERENCE = 'games-difference',
    FORM = 'form',
}

export interface TableStatisticsRow {
    imageKey: string
    name: string
    teamOrTeamMemberId: string
    unitName: string
    statistics: TableStatistics[]
}

/** Lazily resolved translated group table column headers */
export const TranslatedGroupTableColumns = new Proxy(
    {} as Record<string, string>,
    {
        get: (_target, key: string) => {
            const map: Record<string, string> = {
                Points: i18next.t('phase:group-table-columns.points'),
                Appearance: i18next.t('phase:group-table-columns.appearance'),
                Victory: i18next.t('phase:group-table-columns.victory'),
                Draw: i18next.t('phase:group-table-columns.draw'),
                Defeat: i18next.t('phase:group-table-columns.defeat'),
                Goals: i18next.t('phase:group-table-columns.goals'),
                Baskets: i18next.t('phase:group-table-columns.baskets'),
                ConcededGoals: i18next.t(
                    'phase:group-table-columns.conceded-goals'
                ),
                ConcededBaskets: i18next.t(
                    'phase:group-table-columns.conceded-baskets'
                ),
                WonSets: i18next.t('phase:group-table-columns.won-sets'),
                LostSets: i18next.t('phase:group-table-columns.lost-sets'),
                GamesWon: i18next.t('phase:group-table-columns.games-won'),
                GamesLost: i18next.t('phase:group-table-columns.games-lost'),
                GoalDifference: i18next.t(
                    'phase:group-table-columns.goal-difference'
                ),
                BasketDifference: i18next.t(
                    'phase:group-table-columns.basket-difference'
                ),
                SetsDifference: i18next.t(
                    'phase:group-table-columns.sets-difference'
                ),
                GamesDifference: i18next.t(
                    'phase:group-table-columns.games-difference'
                ),
                Form: i18next.t('phase:group-table-columns.form'),
            }
            return map[key]
        },
    }
)

export interface Rows {
    teamOrTeamMemberId: string
    unitName: string
    name: string
    imageKey: string
    statistics: {
        type: string
        value: number
    }[]
    formData?: string[]
}
